import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import PanelFilter from "../../../shares/PanelFilter";
import RingCard from "../../../customer-panels/create-order/RingCard";
import MuiPagination from "../../../shares/MuiPagination";
import useFetch from "../../../../context/useFetch";
import { ageList, colorList, fixNumbers } from "../../../../utils";
import ShowRingSizes from "../../../customer-panels/create-order/ShowRingSizes";
import AddRingTabThree from "../../../customer-panels/create-order/AddRingTabThree";
import PanelTable from "../../../shares/PanelTable";
import { useUserData } from "../../../../context/UserDataContext";
import { useProducerBasket } from "../../../../context/ProducerBasketContext";

// import Others files

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "brand_name", name: "برند" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "color", name: "ج۱" },
  { colName: "color", name: "ج۲" },
  { colName: "color", name: "ج۳" },
  { colName: "color", name: "ج۴" },
  { colName: "color", name: "ج۵" },
  { colName: "color", name: "ج۶" },
  // { colName: "seeـweights", name: "مشاهده وزن‌ها" },
  { colName: "add_ring", name: "افزودن" },
];

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
];
const dataKey = [
  "code",
  "brand_name",
  "show_name",
  "gender",
  "color",
  "admin_size_one_num",
  "admin_size_two_num",
  "admin_size_three_num",
  "admin_size_four_num",
  "admin_size_five_num",
  "admin_size_six_num",
];

const PTabThree = (props) => {
  const { userData } = useUserData();

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [kindFilter, setKindFilter] = useState(null);
  const [colorFilter, setColorFilter] = useState(null);
  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "اسم",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
    {
      type: "select",
      label_fa: "نوع",
      label_en: "kind",
      state: kindFilter,
      menuItems: ageList,
    },
    {
      type: "select",
      label_fa: "رنگ",
      label_en: "color",
      state: colorFilter,
      menuItems: colorList,
    },
  ];
  const {
    userSelectedRing,
    clearBasket,
    selectedUserContext,
    removeRing,
    providerTabThree,
    setProviderTabThree,
  } = useProducerBasket();
  console.log(userSelectedRing);
  const [ringsList, setRingsList] = useState([]);
  const GetRingsApi = useFetch({
    method: "get",
    url: `Provider_Service/${props.selectedUser?.id}/admin_get_provider_bangles_nums_from_timestamp`,
    params: {
      bangle_name: nameFilter,
      bangle_code: fixNumbers(codeFilter),
      bangle_brand: brandFilter,
      bangle_color: colorFilter,
      bangle_gender: kindFilter,
    },

    trigger: props.selectedUser == undefined ? false : true,
    setter: setRingsList,
    argFunc: (res) => {
      console.log(res,'aaaaasadasdasdas')
      setProviderTabThree(res);
    },

    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);
    if (state == "color") setColorFilter(e.length > 0 ? e : null);
    if (state == "kind") setKindFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    GetRingsApi.reFetch();
  };

  // const update_admin_producer_ring_nums = (nums, item) => {
  //   console.log(nums, item);
  //   const rings = [...ringsList];
  //   let it = rings.filter((i) => i.id == item.id)[0];
  //   let it_ind = rings.findIndex((i) => i.id == item.id);
  //   // console.log(it_ind.toExponential,rings[it_ind],'111111')

  //   if (nums[0] !== undefined && nums[0] !== "")
  //     rings[it_ind]["admin_size_one_num"] -= nums[0];
  //   if (nums[1] !== undefined && nums[1] !== "")
  //     rings[it_ind]["admin_size_two_num"] -= nums[1];
  //   if (nums[2] !== undefined && nums[2] !== "")
  //     rings[it_ind]["admin_size_three_num"] -= nums[2];
  //   if (nums[3] !== undefined && nums[3] !== "")
  //     rings[it_ind]["admin_size_four_num"] -= nums[3];
  //   if (nums[4] !== undefined && nums[4] !== "")
  //     rings[it_ind]["admin_size_five_num"] -= nums[4];
  //   if (nums[5] !== undefined && nums[5] !== "")
  //     rings[it_ind]["admin_size_six_num"] -= nums[5];
  // };
  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter("all");
    setKindFilter("all");
    setColorFilter("all");

    GetRingsApi.reFetch();
  };

  const buttonsList = [
    // {
    //   label: "مشاهده وزن‌ها",
    //   component: (it) => <ShowRingSizes selectedRow={it} />,
    // },
  ];
  const actionsList = [
    {
      label: "افزودن",
      component: (it) => (
        <AddRingTabThree
          producerCreateOrder
          selectedRow={it}
          selectedUser={props.selectedUser}
          // update_admin_producer_ring_nums={update_admin_producer_ring_nums}
        />
      ),
    },
  ];

  useEffect(() => {
    GetRingsApi.reFetch();
  }, [props.needRefetch]);

  return (
    <>
      {props.selectedUser !== undefined ? (
        <div className="mb-4">
          <span className="text-myblue-100">
            تولیدکننده انتخاب شده:{" "}
            <span className="text-gray-700">{props.selectedUser?.name}</span>
          </span>
        </div>
      ) : (
        ""
      )}
      <PanelFilter
        header="فیلتر النگوها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      {userData.job == "Admin" ? (
        <PanelTable
          header="محصولات:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={providerTabThree}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AccountBalanceIcon />}
        />
      ) : (
        <div className="grid md:grid-cols-4 md:gap-x-6 gap-y-4 md:gap-y-6">
          {ringsList.map((item, index) => {
            return [
              <>
                <RingCard
                  producerCreateOrder
                  item={item}
                  type={item.gender == "woman" ? "زنانه" : "بچه گانه"}
                />
              </>,
            ];
          })}
        </div>
      )}
    </>
  );
};

export default PTabThree;
